var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { createReducer } from "redux-act";
import { signInSucceeded, signInAutomaticallySucceeded, signOutStart, } from "../../reduxV2/auth/auth.actions";
import { onMultiple } from "../utils/reducer.utils";
import * as authActions from "./auth.actions";
import { getUser, updateUser, removeProfile } from "./auth.actions";
export var REDUCER_KEY_AUTH = "auth";
var getDefaultState = function () { return ({
    isSigningUp: false,
    signUpError: undefined,
    isSignUpVerifyingPhone: false,
    signUpVerifyPhoneError: undefined,
    user: undefined,
    isFetchingUser: false,
    fetchUserError: undefined,
    isUpdatingUser: false,
    updateUserError: undefined,
    isAdminVerifyingEmailOrPhone: false,
    adminVerifyError: undefined,
    isRemovingProfile: false,
    removeProfileError: undefined,
    updateUserById: {},
}); };
var reducer = createReducer({}, getDefaultState());
reducer.on(authActions.signUp.types.START, function (state) { return (__assign(__assign({}, state), { isSigningUp: true, signUpError: undefined })); });
reducer.on(authActions.signUp.types.SUCCESS, function (state, _a) {
    var user = _a.user;
    return (__assign(__assign({}, state), { user: user, isSigningUp: false, signUpError: undefined }));
});
reducer.on(authActions.signUp.types.FAILURE, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isSigningUp: false, signUpError: error }));
});
reducer.on(authActions.signUpVerifyPhone.types.START, function (state) { return (__assign(__assign({}, state), { isSignUpVerifyingPhone: true, signUpVerifyPhoneError: undefined })); });
reducer.on(authActions.signUpVerifyPhone.types.SUCCESS, function (state) { return (__assign(__assign({}, state), { hasAccessToken: true, isSignUpVerifyingPhone: false, signUpVerifyPhoneError: undefined })); });
reducer.on(authActions.signUpVerifyPhone.types.FAILURE, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isSignUpVerifyingPhone: false, signUpVerifyPhoneError: error }));
});
reducer.on(getUser.types.START, function (state) { return (__assign(__assign({}, state), { isFetchingUser: true, fetchUserError: undefined })); });
reducer.on(getUser.types.SUCCESS, function (state, user) {
    if (!user.tac) {
        // eslint-disable-next-line no-console
        console.log("Get user success - User has no tac object", { user: user });
    }
    return __assign(__assign({}, state), { user: user, isFetchingUser: false, fetchUserError: undefined });
});
reducer.on(getUser.types.FAILURE, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isFetchingUser: false, fetchUserError: error }));
});
reducer.on(updateUser.types.START, function (state) { return (__assign(__assign({}, state), { isUpdatingUser: true, updateUserError: undefined })); });
reducer.on(updateUser.types.SUCCESS, function (state, _a) {
    var user = _a.user;
    return (__assign(__assign({}, state), { user: user, isUpdatingUser: false, updateUserError: undefined }));
});
reducer.on(updateUser.types.FAILURE, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isUpdatingUser: false, updateUserError: error }));
});
reducer.on(authActions.updateUserById.types.START, function (state, _a) {
    var _b;
    var id = _a.id;
    return (__assign(__assign({}, state), { updateUserById: __assign(__assign({}, state.updateUserById), (_b = {}, _b[id] = {
            user: undefined,
            isFetching: true,
            fetchError: undefined,
        }, _b)) }));
});
reducer.on(authActions.updateUserById.types.SUCCESS, function (state, _a) {
    var _b;
    var id = _a.id, user = _a.user;
    return (__assign(__assign({}, state), { updateUserById: __assign(__assign({}, state.updateUserById), (_b = {}, _b[id] = {
            user: user,
            isFetching: false,
            fetchError: undefined,
        }, _b)) }));
});
reducer.on(authActions.updateUserById.types.FAILURE, function (state, _a) {
    var _b;
    var id = _a.id, error = _a.error;
    return (__assign(__assign({}, state), { updateUserById: __assign(__assign({}, state.updateUserById), (_b = {}, _b[id] = {
            user: undefined,
            isFetching: false,
            fetchError: error,
        }, _b)) }));
});
reducer.on(removeProfile.types.START, function (state) { return (__assign(__assign({}, state), { isRemovingProfile: true, removeProfileError: undefined })); });
reducer.on(removeProfile.types.SUCCESS, function (state, _a) {
    var user = _a.user;
    return (__assign(__assign({}, state), { user: user, isRemovingProfile: false, removeProfileError: undefined }));
});
reducer.on(removeProfile.types.FAILURE, function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isRemovingProfile: false, removeProfileError: error }));
});
onMultiple(reducer, [
    authActions.adminVerifyEmail.types.START,
    authActions.adminVerifyPhone.types.START,
], function (state, _) { return (__assign(__assign({}, state), { isAdminVerifyingEmailOrPhone: true, adminVerifyError: undefined })); });
onMultiple(reducer, [
    authActions.adminVerifyEmail.types.SUCCESS,
    authActions.adminVerifyPhone.types.SUCCESS,
], function (state, _) { return (__assign(__assign({}, state), { isAdminVerifyingEmailOrPhone: false, adminVerifyError: undefined })); });
onMultiple(reducer, [
    authActions.adminVerifyEmail.types.FAILURE,
    authActions.adminVerifyPhone.types.FAILURE,
], function (state, _a) {
    var error = _a.error;
    return (__assign(__assign({}, state), { isAdminVerifyingEmailOrPhone: false, adminVerifyError: error }));
});
onMultiple(reducer, [signInSucceeded.type, signInAutomaticallySucceeded.type], function (state) { return (__assign(__assign({}, state), { hasAccessToken: true })); });
reducer.on(signOutStart.type, function () { return (__assign(__assign({}, getDefaultState()), { hasAccessToken: false })); });
// eslint-disable-next-line import/no-default-export
export default reducer;
